import React from "react";
import tw from "twin.macro";

const LeadingContainer = tw.div`bg-gray-100 py-6`;
const LeadingWrapper = tw.div`w-full px-4 lg:w-8/12 mx-auto text-xl`;

const Leading = () => (
  <LeadingContainer>
    <LeadingWrapper>
      The DMACC provides multi-disciplinary expertise in information
      technology, clinical research informatics, clinical trials auditing,
      clinical trials methodology and biostatistics, and operations management
      to support CP-CTNet activities.
    </LeadingWrapper>
  </LeadingContainer>
);

export default Leading;
